<template>
  <div id="app">
    <div class="container">
      <VueSignaturePad
        height="300px"
        :customStyle="{ border: '#707070 1px solid', borderRadius: '8px' }"
        ref="signaturePad"
        :options="{ dotSize: 5, minWidth: 5, maxWidth: 5 }"
      />
      <span v-show="teste" class="text-brand-5 text-weight-bold teste"
        >Assine Aqui</span
      >
    </div>
    <div class="row col-12 justify-between q-mt-md">
      <div>
        <q-btn
          @click="undo"
          color="negative"
          icon="delete"
          dense
          no-caps
          flat
          rounded
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["update", "assinar"],
  props: ["restart", "go"],
  name: "MySignaturePad",

  methods: {
    undo() {
      this.$refs.signaturePad.clearSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      console.log(isEmpty);

      this.$emit("update", data);
    },
    teste() {
      this.$emit("assinar");
    },
  },
  watch: {
    restart() {
      this.undo();
    },
    go() {
      this.save();
    },
  },
};
</script>

<style scoped>
canvas {
  border: 1px solid #707070;
  background-color: white;
  cursor: crosshair;
  border-radius: 10px;
}

.buttonsCanvas {
  margin-top: 100px;
}

.save {
  margin-left: 10px;
}
.container {
  position: relative;
}
.teste {
  position: absolute;
  top: 110px;
  font-size: 50px;
  left: 160px;
  opacity: 0.3;
  z-index: -1;
}
@media only screen and (max-width: 635px) {
  .teste {
    position: absolute;
    top: 110px;
    font-size: 40px;
    left: 80px;
    opacity: 0.3;
    z-index: -1;
  }
}
</style>
class="buttonsCanvas"
